import SignIn from '@views/common/auth/SignIn';
import React from 'react';
import GenericNavbarLayout from './GenericNavbarLayout';
import { NavLinkData } from '../util/navLinkData';
import { RouteLayoutProps } from './routeLayoutProps';
import Home from '@views/common/Home';
import ForgotPassword from '@views/common/auth/ForgotPassword';
import ResetSent from '@views/common/auth/ResetSent';

const anonymousRoutes: NavLinkData[] = [
  {
    text: 'Home',
    to: '/',
    component: Home,
    inNavbar: true,
  },
  {
    text: 'Sign In',
    to: '/signin',
    component: SignIn,
    inNavbar: true,
  },
  {
    to: '/forgotpassword',
    component: ForgotPassword,
    inNavbar: false,
  },
  {
    to: '/resetsent',
    component: ResetSent,
    inNavbar: false,
  },
];

const AnonymousLayout: React.FC<RouteLayoutProps> = ({ baseRoutes }) => {
  const allowedRoutes = baseRoutes.concat(anonymousRoutes);

  return <GenericNavbarLayout allowedRoutes={allowedRoutes}></GenericNavbarLayout>;
};

export default AnonymousLayout;
